import styled from "styled-components";

export const DonationNavBarMobileContainer = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  background-color: white;
  margin: 0;
`

export const BorderLine = styled.div`
  position: absolute;
  width: 100vw;
  height: 1px;
  left: -25px;
  bottom: 10px;
  background-color: var(--color-donation-input-border);
`

export const DonationNavBarMobileRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
  margin-bottom: 10px;
`
